<template>
  <div class="home">
    <div class="box_content">
      <div class="left">
        <p>粉丝概况
          <span>(由于微信接口问题，暂时无法获取粉丝数据)</span>
        </p>
        <div class="value_box">
          <div class="value_left">
            <div class="value_line"> <i class="el-icon-user" style="color:#409eff"></i> ---</div>
            <div class="name_line">今日新增粉丝</div>
          </div>
          <div class="value_right">
            <div class="value_line"> <i class="el-icon-user" style="color:#409eff"></i> ---</div>
            <div class="name_line">总粉丝量</div>
          </div>
        </div>
      </div>
      <div class="right">
        <img src="/public/img/all/logo.png" alt="">
        <div class="status_text">服务号 <div>{{empower_status}}</div></div>
        <div class="empower_button">
          <el-button v-if="noEmpower" type="text" @click="gotoEmpower">前往授权</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetEmpower } from "@/api/configuration";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "status"])
  },
  data(){
    return{
      empower_status: "未认证",
      noEmpower: true,
    }
  },
  mounted(){
    this.getData();
  },
  methods:{
    getData(){
      var data = {
        token: this.token,
        app_id: this.app_id
      }
      GetEmpower(data).then(res=>{
        if(res.code == 200){
          this.noEmpower = false;
          this.empower_status = "已认证"
          if(this.getUrlParam('appid')){
            console.log('带参数')
            this.$message({
              type: "success",
              message: "认证成功！"
            })
          }
        }else if(res.code == 400){
          this.noEmpower = true;
        }else{
          this.$message(res.msg)
        }
      })
    },
    gotoEmpower(){
      // this.$router.push({path:'/configuration/subScription/empower',query:{formHome:"1"}})
      var url = "https://www.58zltc.com/#/empower?appid=" + this.app_id
      if(this.status == "test"){
        url = "https://cs.58zltc.com/#/empower?appid=" + this.app_id
      }
      window.location.href = url;
    },
    getUrlParam(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    }
  }
}
</script>
<style lang="scss" scoped>
.home{
  padding: 20px;
  .box_content{
    display: flex;
    .left{
      border-radius: 10px;
      background: #fff;
      flex:3;
      p{
        margin-top: 15px;
        padding-left: 18px;
        font-size: 16px;
        span{
          color: #999;
          font-size: 13px;
        }
      }
      .value_box{
        display: flex;
        padding: 20px 0;
        margin-bottom: 15px;
        div{
          text-align: center;
        }
        .value_left{
          flex:1;
          border-right:1px solid #eee;
        }
        .value_right{
          flex:1
        }
        .value_line{
          font-size: 25px;
        }
        .name_line{
          margin-top: 13px;
          color: #999;
          font-size: 12px;
        }
      }
    }
    .right{
      margin-left: 15px;
      border-radius: 10px;
      padding-top: 50px;
      padding-left: 95px;
      background: #fff;
      flex: 1;
      position: relative;
      img{
        margin-bottom: 20px;
      }
      .status_text{
        color: #999;
        div{
          color: #5cb87a;
          border: 1px solid #5cb87a;
          margin-left: 10px;
          display: inline-block;
          padding: 2px;
          border-radius: 5px;
        }
      }
      .empower_button{
        position: absolute;
        right:10px;
        top: 12px;
      }
    }
  }
}
</style>